// 配置API接口地址
class ApiService{
     ApiRoot = process.env.API_ROOT;
     LoginUrl=process.env.LOGIN_URI

}
export default ApiService;


// WEBPACK FOOTER //
// ./src/services/api-service.js